<template>
  <div>
    <el-row :gutter="10"
            style="padding-bottom:10px">
      <el-col :span="20">
        <el-button type="primary"
                   @click="toAdd">
          新增
        </el-button>
      </el-col>
    </el-row>
    <Table ref="TablesRef"
           :tableData="tableData" />
    <addForm ref="addFormRef" />
    <EditForm ref="EditFormRef" />

    <pagination ref="pagination"
                :get-data="initData"
                :now-page.sync="page"
                :now-size.sync="size"
                :total="totalElements" />
  </div>
</template>

<script>
import addForm from './components/index.vue'
import EditForm from './components/editForm.vue'
import { sheetUrl } from '@/utils/basicUrl.js'
export default {
  data () {
    return {
      tableData: [],
      page: 1,
      size: 10,
      totalElements: 0,
      tableLoading: false,
      pageName: 'cz_chapter_admin',
      tableColumns: [
        { prop: 'edu_paper_id', align: 'center', label: 'ID', width: '100', showToopic: false },
        { prop: 'paper_name', align: 'center', label: '试卷名称', width: '', showToopic: true },
        { prop: 'subject_name', align: 'center', label: '科目名称', width: '', showToopic: false },
        // { prop: 'paper_district_desc', align: 'center', label: '试卷地区', width: '', showToopic: false },
        // { prop: 'check_point_desc', align: 'center', label: '知识点名称', width: '', showToopic: false, },
        { prop: 'paper_score', align: 'center', label: '总分', width: '100', showToopic: false },
        { prop: 'chapter', align: 'center', label: '章节', width: '', showToopic: false },
        { prop: 'paper_time', align: 'center', label: '开始时间', width: '', showToopic: false, sortable: true },
        { prop: 'end_time', align: 'center', label: '截止时间', width: '', showToopic: false, sortable: true },
        // { prop: 'show_to_desc', align: 'center', label: '可见性', width: '', showToopic: false, },
        { prop: 'paper_enable', align: 'center', label: '是否提交', width: '', showToopic: false, isStatus: true },
        { prop: 'sheet_status', prop1: 'sheet_status2', align: 'center', label: '答题卡状态', width: '', showToopic: false, isStatus: true, twoRow: true },
        {
          prop: 'd', align: 'center', label: '操作', width: '250', type: 'img', btns: [
            { content: '修改', type: 'edit', event: 'editRow' },
            { content: '查看', type: 'look', event: 'toInfo' },
            { content: '制作答题卡', type: 'export', event: 'exportCard' },
            { content: '面批', event: 'toCorrectPaper', isBtnStatus: true },
            { content: '收藏', event: 'collect', type: "collect", isChangeType: true },
            { content: '删除', type: 'del', event: 'delRow' },
          ]
        },
      ]
    }
  },
  components: {
    addForm, EditForm
  },
  mounted () {
    this.setTablesColums()
  },
  methods: {
    getClass (prop, value, row) {
      if (prop == 'knowledge') {
        return ''
      }
      return value ? 'pass' : 'notpass'
    },
    getValue (prop, value, row) {
      if (prop == 'knowledge') {
        return row.knowledge ? Object.values(row.knowledge).join(',') : ''
      }
      if (prop == 'paper_enable') {
        return value ? '已提交' : '未提交'
      }
      if (prop == 'sheet_status' || prop == 'sheet_status2') {
        //"关联答题卡数据状态"  0 未关联  -1 取消申请 1 制作中  2 制作完成，未确定 3 已生成 4 申请中",
        switch (value) {
          case 0: return "未关联";
          case -1: return "取消申请";
          case 1: return "制作中";
          case 2: return "制作完成，未确定";
          case 3: return "已生成";
          case 4: return "申请中";
          default: break;
        }
      }
    },
    getIconContent (opItem, row) {
      if (opItem.type == "collect") {
        if (row['is_collect'] == 0) {
          return '收藏'
        } else {
          return '取消收藏'
        }
      }
    },
    getIconType (opItem, row) {
      if (opItem.type == "collect") {
        if (row['is_collect'] == 0) {
          return 'collect'
        } else {
          return 'cancelCollect'
        }
      }
    },
    setTablesColums () {
      this.$refs.TablesRef.pageName = this.pageName
      this.$refs.TablesRef.setColumns(this.tableColumns)
    },
    toAdd () {
      let form = {
        paper_name: '',
        subject_id: '',
        district_id: '',
        paper_time: '',
        chapter_id: [],
        semester: 2,
        end_time: '',
        edu_paper_type: '',
        given_garde: '',
        given_class: '',
        paper_duration: '',
        question_num: 10,
        difficulty: '',
        question_year: '',
        source_id: 1,
        textbook_id: '',
      }
      this.$refs.addFormRef.form = form
      this.$refs.addFormRef.getList()
      this.$refs.addFormRef.dialogVisible = true
    },
    initData (page, limit) {
      this.$http({
        url: '/api/v1/combination/chapter',
        method: 'POST',
        data: {
          page, limit
        }
      }).then(res => {
        this.tableData = res.data.list.map(item => {

          if (item.chapter instanceof Object) {
            item.chapter = Object.values(item.chapter).join(',')
          } else {
            item.chapter = ''
          }
          return item
        })
        this.totalElements = res.data.count
      })
    },
    toInfo (row) {
      this.$router.push('/testPapercomposition/chapter/info?edu_paper_id=' + row.edu_paper_id)
    },
    delRow (row) {
      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: '/api/v1/combination/del_edu_paper',
          method: 'post',
          data: {
            edu_paper_id: row.edu_paper_id
          }
        }).then(() => {
          this.$notify({
            title: '提示',
            message: '成功!',
            type: 'success'
          });
          this.refresh()
        })
      })
    },
    // 刷新
    refresh () {
      this.$refs.pagination.shuaxin()
    },
    // 查询
    search () {
      this.$refs.pagination.toFirstPage()
    },
    editRow (row) {
      this.$http({
        url: '/api/v1/combination/getPaperInfoAndRelation',
        method: 'get',
        params: {
          id: row.edu_paper_id
        }
      }).then(res => {
        this.$refs.EditFormRef.getPaperTypeList(res.data.info)
        this.$refs.EditFormRef.dialogVisible = true
      })
    },
    collect (row) {
      this.$http({
        url: '/api/v1/combination/collect',
        method: 'post',
        data: {
          edu_paper_id: row.edu_paper_id
        }
      }).then(() => {
        this.$notify({
          title: '提示',
          message: '成功!',
          type: 'success'
        });
        this.refresh()
      })
    },
    // exportCard (row) {
    //   this.$router.push(`/testPapercomposition/makeSheet?id=${row.edu_paper_id}&sheet_id=${row.sheet_id}&status=${row.sheet_status}`)
    // },
    exportCard (row) {
      //this.$router.push(`/testPapercomposition/makeSheet?id=${row.edu_paper_id}&sheet_id=${row.sheet_id}&status=${row.sheet_status}&correct_type=0`)
       let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
       window.open(`${sheetUrl}/#/?czb=1&paper_id=${row.edu_paper_id}&cannot_edit=1&t=${userInfo.token}&rt=${userInfo.refresh_token}`, '_blank')
    },
    toCorrectPaper (row) {
      this.$router.push('/correctPaperCard?edu_paper_id=' + row.edu_paper_id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>